import * as React from 'react'
import { Modal, Progress } from '@/shared/ui'
import { IconCircleCheck, IconAlertTriangle } from '@tabler/icons-react'

export type BootProgressModalProps = {
  open: boolean
  percent: number
  title?: string
  description?: string
  onOpenChange?: (v: boolean) => void
  timeframes?: Array<{ tf: string; status: 'pending' | 'running' | 'done' }>
}

export function BootProgressModal({
  open,
  percent,
  title = 'Preparando histórico (Bybit)',
  description = 'Coletando 500 candles por timeframe diretamente da Bybit e sincronizando manutenção contínua (5m + derivação).',
  onOpenChange,
  timeframes = [],
}: BootProgressModalProps) {
  const pct = Math.max(0, Math.min(100, Math.round(percent || 0)))
  return (
    <Modal open={open} onOpenChange={onOpenChange || (() => {})} className="p-6 sm:p-8" style={{ width: 520, maxWidth: 520 }}>
      <div className="mb-2 text-lg font-semibold">{title}</div>
      <div className="mb-3 text-sm text-foreground/70">{description}</div>
      <Progress value={pct} />
      <div className="mt-2 text-xs text-foreground/70">{pct}%</div>
      {timeframes.length > 0 && (
        <div className="mt-4 grid grid-cols-3 gap-2 text-xs">
          {timeframes.map((t, i) => (
            <div key={t.tf + '-' + i} className="flex items-center justify-between rounded border border-border/60 px-2 py-1">
              <span>{t.tf}</span>
              {t.status === 'done' ? (
                <IconCircleCheck size={16} className="text-emerald-500" />
              ) : (
                <IconAlertTriangle size={16} className="text-amber-500" />
              )}
            </div>
          ))}
        </div>
      )}
    </Modal>
  )
}

